export enum AppendValueType {
  Percentage = '%',
  Currency = '$',
}
